/** @jsxImportSource @emotion/react */
import { formatErrorResponse } from '@quickbit/backoffice-core-frontend';
import {
  Card,
  Icon,
  Loader,
  Snackbar,
  Typography,
  useTheme,
} from '@quickbit/qb-design-system';
import { useSearchParams } from 'react-router-dom';
import { JsonDiff } from 'tabs/AppUsers/components/AppUserDetails/components/JsonDiff';
import { useGetOnboardingHistory } from '../../api';

interface Props {
  userId: string;
}

export const AffiliateOnboardingHistoryTable = ({ userId }: Props) => {
  const {
    data: onboardingHistory,
    isLoading,
    error,
  } = useGetOnboardingHistory(userId);
  const { spacing, palette } = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <>
      <div css={{ marginBottom: spacing.xs }}>
        <Typography variant="heading2">Onboarding History</Typography>
      </div>
      {isLoading && <Loader />}
      {error && (
        <Snackbar
          variant="danger"
          message={formatErrorResponse(error)}
          open={!!error}
        />
      )}
      {onboardingHistory?.events.map((event, idx) => (
        <Card key={`event-${idx}`}>
          <Typography variant="body">
            {event.eventType === 'account_closed'
              ? 'Account closed'
              : event.eventType}{' '}
            — {event.occurredOn}
            {event.note ? ` (${event.note})` : ''}
          </Typography>
        </Card>
      ))}
      {onboardingHistory &&
        onboardingHistory.onboardingHistory.map((historyEntry, idx) => (
          <Card key={idx}>
            <div
              css={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                cursor: 'pointer',
              }}
              onClick={() => {
                searchParams.set('userType', 'null');
                searchParams.set('tab', 'transactions');
                searchParams.set('transactionId', historyEntry.transactionId);
                setSearchParams(searchParams);
              }}
            >
              <JsonDiff
                key={idx}
                oldObject={
                  idx + 1 >= onboardingHistory.onboardingHistory.length
                    ? {}
                    : onboardingHistory.onboardingHistory[idx + 1].change
                }
                newObject={historyEntry.change}
              />
              <div
                css={{
                  transform: 'rotate(180deg)',
                  padding: `0 ${spacing.xxs}`,
                  svg: { fill: 'none', stroke: palette.grey.x300 },
                }}
              >
                <Icon name="chevron" />
              </div>
            </div>
          </Card>
        ))}
    </>
  );
};
